module.exports = __webpack_public_path__ + "static/media/farm.fd6451ed.svg";